document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.toggle-content');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('.card');
        const header = card.querySelector('.card-header');
        const content = card.querySelector('.card-content');
        const isActive = content.classList.contains('active');

        document.querySelectorAll('.card-content').forEach((c) => {
          c.classList.remove('active');
          c.style.maxHeight = null;
        });

        document.querySelectorAll('.card-header').forEach((h) => {
          h.classList.remove('active');
          h.style.transform = 'translateY(0)';
        });

        document.querySelectorAll('.toggle-content').forEach((b) => b.classList.remove('rotate'));

        if (!isActive) {
          content.classList.add('active');
          const contentHeight = content.scrollHeight;
          content.style.maxHeight = contentHeight + 'px';
          button.classList.add('rotate'); // vertical line hides → minus

          setTimeout(() => {
            header.classList.add('active');
            header.style.transform = `translateY(-${contentHeight}px)`;
          }, 10);
        }
      });
    });
  });